export type BonusProps = {
    page: BonusPage;
    setPage: (page: BonusPage) => void;
};

export enum BonusPage {
    BONUS_PAGE = 'bonus',
    LINKS_PAGE = 'links',
    HOLDERS_PAGE = 'holders',
}
